module.exports = __webpack_public_path__ + "static/map-c88bf3f643223cefc26f24225bc0ef36.svg";